import classNames from "classnames";
import { useMixpanelTracking } from "lib/hooks/useMixpanelTracking";
import Button from "components/buttonNew/button";
import type { ProductShelfItem } from "content-ui/utilityPages/about/types";

export default function ProductShelf({
  products = [],
}: {
  products: ProductShelfItem[];
}) {
  const { track } = useMixpanelTracking();

  return (
    <ul className="grid lg:grid-cols-3 lg:gap-[35px]">
      {Array.isArray(products) &&
        products.length > 0 &&
        products?.map((description, i) => (
          <li
            key={i}
            className={classNames(
              "flex flex-col items-start justify-between border-t-2 border-t-black pb-[40px]",
              "pt-[10px] md:flex-row md:items-center lg:flex-col lg:items-start"
            )}
          >
            <div>
              <h2 className="font-recklessBold text-[32px] leading-[130%] md:max-w-[650px]">
                {description?.title}
              </h2>
              <p className="mt-[10px] leading-[130%] text-mono-70 md:block md:max-w-[650px]">
                {description?.description}
              </p>
            </div>
            <Button
              colour={description?.ctaColor || "black"}
              size="medium"
              component={"link"}
              href={description?.ctaLink}
              className="mt-5 flex-shrink-0 md:ml-2 md:mt-0 md:self-center md:justify-self-end lg:ml-0 lg:mt-5 lg:self-start"
              onClick={async () => {
                await track("About page click", {
                  "Click link": description?.ctaLink,
                  "Click text": description?.ctaText,
                });
              }}
            >
              {description?.ctaText}
            </Button>
          </li>
        ))}
    </ul>
  );
}
